import {Routes} from '@angular/router';

import {getPollResolver} from '../../../shared/services/resolvers/get-poll.resolver';
import {getUnitUserPollResolver} from '../../../shared/services/resolvers/get-unit.resolver';
import {AnalyticalComponent} from './analytical/analytical.component';
import {EngagementComponent} from './engagement/engagement.component';
import {EvolutionComponent} from './evolution/evolution.component';
import {FeedbackComponent} from './feedback/feedback.component';
import {ManagementDiaryComponent} from './management-diary/management-diary.component';
import {MeterComponent} from './meter/meter.component';
import {ReportDataComponent} from './report-data.component';
import {SummaryComponent} from './summary/summary.component';
import {WordcloudComponent} from './wordcloud/wordcloud.component';
import {IncentiveComponent} from "./incentive/incentive.component";
import {ReservationComponent} from './reservation/reservation.component';
import {ShiftComponent} from './shift/shift.component';

export const reportDataRoutes: Routes = [
  {
    path: ':id',
    resolve: {
      poll: getPollResolver,
      unitUserPoll: getUnitUserPollResolver,
    },
    loadComponent: () => ReportDataComponent,
    children: [
      {
        path: 'managementDiary',
        loadComponent: () => ManagementDiaryComponent,
      },
      {
        path: 'summary',
        loadComponent: () => SummaryComponent,
      },
      {
        path: 'engagement',
        loadComponent: () => EngagementComponent,
      },
      {
        path: 'feedback',
        loadComponent: () => FeedbackComponent,
      },
      {
        path: 'evolution',
        loadComponent: () => EvolutionComponent,
      },
      {
        path: 'analytical',
        loadComponent: () => AnalyticalComponent,
      },
      {
        path: 'wordcloud',
        loadComponent: () => WordcloudComponent,
      },
      {
        path: 'meter',
        loadComponent: () => MeterComponent,
      },
      {
        path: 'incentive',
        loadComponent: () => IncentiveComponent,
      },
      {
        path: 'reservation',
        loadComponent: () => ReservationComponent,
      },
      {
        path: 'shift',
        loadComponent: () => ShiftComponent,
      }
    ],
  },
];
